import { ListBoxItem, ListBoxItemProps } from "react-aria-components";
import { ArrowRight } from "react-feather";
import { useState } from "react";

import styles from "./location-list-item.module.css";
import LocationNamePlate from "./location-name-plate";

export default function LocationListItem(props: ListBoxItemProps) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <ListBoxItem
      {...props}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className={styles.location}
    >
      <div className={styles.locationItem}>
        <LocationNamePlate isHovered={isHovered} name={props.textValue || ""} />
        <ArrowRight className={styles.arrow} />
      </div>
    </ListBoxItem>
  );
}
